import { render, staticRenderFns } from "./TranzilaProvider.vue?vue&type=template&id=57c1b8d4&"
import script from "./TranzilaProvider.vue?vue&type=script&lang=ts&"
export * from "./TranzilaProvider.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports